var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 6V12.6C2.25 13.4401 2.25 13.8601 2.41349 14.181C2.5573 14.4632 2.78677 14.6927 3.06901 14.8365C3.38988 15 3.80992 15 4.65 15H13.35C14.1901 15 14.6101 15 14.931 14.8365C15.2132 14.6927 15.4427 14.4632 15.5865 14.181C15.75 13.8601 15.75 13.4401 15.75 12.6V8.025C15.75 7.53668 15.75 7.29253 15.6937 7.09284C15.552 6.59054 15.1595 6.19798 14.6572 6.05632C14.4575 6 14.2133 6 13.725 6M2.25 6V5.4C2.25 4.55992 2.25 4.13988 2.41349 3.81901C2.5573 3.53677 2.78677 3.3073 3.06901 3.16349C3.38988 3 3.80992 3 4.65 3H11.325C12.1651 3 12.5851 3 12.906 3.16349C13.1882 3.3073 13.4177 3.53677 13.5615 3.81901C13.725 4.13988 13.725 4.55992 13.725 5.4V6M2.25 6H13.725M15.75 9H14.25C13.4216 9 12.75 9.67157 12.75 10.5C12.75 11.3284 13.4216 12 14.25 12H15.75V9Z",
    stroke: "#152B35",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.0a06f1a3306cdf664c3a759cf2002f99.svg";
export { ForwardRef as ReactComponent };